/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hours_SaturdayInputs */

const en_contact_hours_saturday = /** @type {(inputs: Contact_Hours_SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday`)
};

const pl_contact_hours_saturday = /** @type {(inputs: Contact_Hours_SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobota`)
};

/**
* | output |
* | --- |
* | "Saturday" |
*
* @param {Contact_Hours_SaturdayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_hours_saturday = /** @type {((inputs?: Contact_Hours_SaturdayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hours_SaturdayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_hours_saturday(inputs)
	return en_contact_hours_saturday(inputs)
});